import { SIZE_TYPE } from '../renderMixin'

export default {
  // moduleName: '',
  title: '',
  subTitle: '',
  backgroudImages: [],
  isShowSearchBox: false,
  interval: null,
  size: {
    width: {
      type: SIZE_TYPE.AUTO,
      fixed: null,
      percentage: null
    },
    height: {
      type: SIZE_TYPE.AUTO,
      fixed: null,
      percentage: null
    }
  }
}
